var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelefonoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B444D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,1.6c0-0.7,0.6-1.4,1.4-1.4c7.5,0,13.6,6.1,13.6,13.6c0,0.7-0.6,1.4-1.4,1.4S30,14.6,30,13.8 C30,7.8,25.2,3,19.2,3C18.4,3,17.8,2.4,17.8,1.6z M19.2,8.4c3,0,5.4,2.4,5.4,5.4c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4 c0-4.5-3.6-8.1-8.1-8.1c-0.7,0-1.4,0.6-1.4,1.4S18.4,8.4,19.2,8.4z M31.5,23c1.6,1.6,1.6,4.3,0,5.9l-1.2,1.4 C19.2,41-7.9,13.9,2.6,2.8l1.6-1.4C5.8-0.2,8.4-0.1,10,1.5c0,0,2.6,3.3,2.6,3.3c1.5,1.6,1.5,4.2,0,5.8l-1.6,2 c1.8,4.3,5.1,7.7,9.4,9.4l2-1.6c1.6-1.6,4.2-1.6,5.8,0C28.2,20.4,31.5,22.9,31.5,23z M29.7,24.9c0,0-3.2-2.5-3.3-2.5 c-0.6-0.6-1.5-0.6-2.1,0c0,0-2.8,2.2-2.8,2.2c-0.4,0.3-0.9,0.4-1.3,0.2c-5.5-2.1-9.9-6.4-12-12c-0.2-0.5-0.1-1,0.2-1.4 c0,0,2.2-2.7,2.2-2.8c0.6-0.6,0.6-1.5,0-2.1c0,0-2.5-3.3-2.5-3.3C7.5,2.8,6.6,2.8,6,3.4L4.5,4.8C-3.2,14,20.2,36.1,28.3,28.5 l1.2-1.4C30.1,26.5,30.2,25.6,29.7,24.9L29.7,24.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefonoFooter);
export default __webpack_public_path__ + "static/media/Telefono_footer.57f95e55277f34dd6181b537a498538a.svg";
export { ForwardRef as ReactComponent };